var Alberta = "Alberta";
var Manitoba = "Manitoba";
var Nunavut = "Nunavut";
var Ontario = "Ontario";
var Quebec = "Quebec";
var Saskatchewan = "Saskatchewan";
var Yukon = "Yukon";
var CAStates = {
	Alberta: Alberta,
	"British Columbia": "Britisch-Kolumbien",
	Manitoba: Manitoba,
	"New Brunswick": "Neubraunschweig",
	"Newfoundland and Labrador": "Neufundland und Labrador",
	"Northwest Territories": "Nordwest-Territorien",
	"Nova Scotia": "Neuschottland",
	Nunavut: Nunavut,
	Ontario: Ontario,
	"Prince Edward Island": "Prince Edward Island",
	Quebec: Quebec,
	Saskatchewan: Saskatchewan,
	Yukon: Yukon
};

export { Alberta, Manitoba, Nunavut, Ontario, Quebec, Saskatchewan, Yukon, CAStates as default };
